import React, { useState, useEffect } from 'react'
import api from '../../components/api'

import { onlyNumberWithTwoDecimal } from '../../components/functions'
import Table from 'react-bootstrap/Table'

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { useEnergiaIluminacaoContext } from '../../context/energiaIluminacaoContext'
import { useTabelaGestao } from '../../context/GestaoPendenciasContext'

import { Link } from 'react-router-dom'
import { useEnunciadoContext } from '../../context/enunciadoContext'
import { useVerificaDesafioContext } from '../../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../../context/secaoEnunciadoContext'

import StatusValidacaoSecao from '../StatusValidacaoSecao';

const Iluminacao = (props) => {

    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id
    var energia_id = props.energia_id


    const {energiaIluminacao_id, setEnergiaIluminacao_id} = useEnergiaIluminacaoContext()



    const [resultadoIluminacao, setResultadoIluminacao] = useState()

    const [informa, setInforma] = useState(true)




    useEffect(() => {

        consultaIluminacao()
        consultaInforma()

    }, [ano, energia_id, atualizacaoGestao])





    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()




    const [questao, setQuestao] = useState()
    const [totalPendencias, setTotalPendencias] = useState(0)



    useEffect(() => {

        var dataPost = {

            tipo: 'informaIluminacao',
            informa: informa,

        }

        api.post(`energiaInforma/${energia_id}`, dataPost).then((result) => {

            console.log(result.data)

        }).catch((err) => {

            console.log(err.response)

        })

    }, [informa])



    const consultaInforma = () => {

        api.get(`energiaInforma/${energia_id}/informaIluminacao`).then((result) => {

            //console.log(result.data)
            setInforma(result.data[0].informaIluminacao)

        }).catch((err) => {

            console.log(err.response)

        })
    }






    useEffect(() => {

        verificaValidacoes()
        consultaInforma()

    }, [energia_id, verificaDesafio])


    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao()
        

        if (energia_id) {

            var dataPost = {

                formulario_id: energia_id,
                desafio: 'Energia',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                //console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case 'Iluminação':

                                totalErros = totalErros + 1
                                setQuestao('red')
    
                            break

                            
                        }

                    }
                    

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }







    function consultaIluminacao() {

        // console.log(energia_id, '!!')
        api.get(`energiaIluminacaoListaTodos/${energia_id}`).then((result) => {

            //console.log(result.data)
            setResultadoIluminacao(result.data.map((rs) =>

                <tr style={{ cursor: 'pointer'}} onClick={() => {window.$('#modalEnergiaIluminacao').modal('show');setEnergiaIluminacao_id(rs.energiaIluminacao_id)}}>
                    <td>
                        {rs.tipoTecnologia}
                    </td>
                    <td style={{ textAlign: 'center'}}>
                        {rs.marca}
                    </td>
                    <td style={{ textAlign: 'right'}}>
                        {rs.quantidade}
                    </td>
                    <td>
                        {rs.identificacao}
                    </td>
                </tr>
            
            ))


        }).catch((err) => {

            console.log(err.response)

        })

    }



    



    return (
        <div>

            <div className="col-md-12">
                <div align="left">

                
                    <select className="form-control" value={informa} onChange={event => setInforma(event.target.value)}>
                        <option value={true}>A instituição possui o(s) equipamento(s) e reportará suas informações</option>
                        <option value={false}>A instituição não possui o(s) equipamento(s) ou a instituição possui o(s) equipamento(s) mas não reportará suas informações</option>
                    </select>
                    <br/>

                </div>
            </div>
            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>
                <div align="left">

                
                    <Link to='#' style={{ color: questao }} onClick={() => {setEnunciado('Iluminação');setSecaoEnunciado('Iluminação');window.$('#modalValidacao').modal('show')}}>
                    [Informar Não Conformidade]</Link>
                    <br/><br/>
                    
                    
                    <button type="button" className="btn btn-primary" onClick={() => {window.$('#modalEnergiaIluminacao').modal('show');setEnergiaIluminacao_id()}}  >+ Adicionar</button>&nbsp;
                    <button type="button" className="btn btn-info" onClick={() => window.$('#modalEnergiaIluminacaoResumo').modal('show')}  >Resumo</button>
                    <br/><br/>

                </div>
            </div>


            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>


                <Table striped bordered hover>

                    <thead>
                        
                        <tr>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Tipo/Tecnologia

                            </th>
                            <th style={{backgroundColor: '#e6f7ec', textAlign: 'center'}}>

                                Marca

                            </th>
                            <th style={{backgroundColor: '#e6f7ec', textAlign: 'center'}}>

                                Quantidade

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Ambiente

                            </th>
                           

                        </tr>
                    </thead>
                    <tbody>
                        {resultadoIluminacao}
                    </tbody>

                </Table>

            </div>


            <StatusValidacaoSecao desafio="Energia" secaoCampo="secaoIluminacao" totalPendencias={totalPendencias} nomeDesafio="Desafio Energia" formulario_id={energia_id} secao="Iluminação" ano={ano} />


        </div>
    )


}

export default Iluminacao